import angular from 'angular';
import reaSecurities from './reaSecurities';
import './style.scss';

export default angular
  .module('fundingDetailsSection.scenes.reaSecurities', [])
  .component('reaSecurities', reaSecurities).name;
